const Icon = ({
    base64,
    alt,
    className,
    width = 22,
    height = 22
}) => {

    if (!base64) {
        return <div className="text-gray-500">No SVG data provided</div>;
    }

    return <img
        src={base64}
        alt={alt}
        height={height}
        className={className}
        width={width}
    />;
};

export default Icon;